/* ─────────────────────────────────────────────
   theme.js — Lesly Curlz × Shopify
   Global JS: scroll animations, navbar, promo bar, mobile menu, back-to-top
───────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', () => {

  // ── Scroll animations ─────────────────────
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('animated'); });
  }, { threshold: .1, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.animate-on-scroll,.animate-left,.animate-right,.animate-scale')
    .forEach(el => obs.observe(el));

  // ── Navbar scroll ──────────────────────────
  const navbar = document.getElementById('navbar');
  const btt    = document.getElementById('backToTop');
  window.addEventListener('scroll', () => {
    navbar?.classList.toggle('scrolled', window.scrollY > 60);
    btt?.classList.toggle('visible', window.scrollY > 400);
  });

  // ── Promo bar close ────────────────────────
  document.getElementById('promoClose')?.addEventListener('click', () => {
    document.documentElement.classList.add('promo-closed');
    localStorage.setItem('promoBarClosed', Date.now().toString());
  });

  // ── Mobile menu ────────────────────────────
  const menuBtn    = document.getElementById('menuBtn');
  const mobileMenu = document.getElementById('mobileMenu');
  menuBtn?.addEventListener('click', () => {
    const open = mobileMenu.classList.toggle('open');
    menuBtn.setAttribute('aria-expanded', String(open));
    menuBtn.classList.toggle('open');
    document.body.style.overflow = open ? 'hidden' : '';
  });
  document.querySelectorAll('.close-menu').forEach(el => el.addEventListener('click', () => {
    mobileMenu?.classList.remove('open');
    menuBtn?.classList.remove('open');
    menuBtn?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }));

  // ── Back to top ────────────────────────────
  btt?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

  // ── Promo bar: restore closed state early ──
  // (also done inline in <head> for flash prevention)
  try {
    const t = +localStorage.getItem('promoBarClosed') || 0;
    if (t && Date.now() - t < 604800000) {
      document.documentElement.classList.add('promo-closed');
    }
  } catch (e) { /* private browsing */ }

});
